import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronRight, Download, Plus, Search, Users } from "lucide-react";
import { downloadExcel } from "@/lib/exportData";
import { inr, useCan, useLoad } from "@/lib/api";
import { Empty, ErrorBox, PageHeading } from "@/components/common";
import PatientForm from "@/components/forms/PatientForm";

export default function Patients() {
  const navigate = useNavigate();
  const can = useCan();
  const [q, setQ] = useState("");
  const [show, setShow] = useState(false);
  const { data: patients, error, reload, loading } = useLoad(`/patients?q=${encodeURIComponent(q)}`, []);
  const money = can("ledger:read");
  return (
    <div className="content">
      <PageHeading eyebrow="PATIENTS / MASTER REGISTER" title="People at the" accent="centre." sub="Every visit, treatment and payment starts with a trusted patient record.">
        {can("team") && <button className="secondary" onClick={downloadExcel} data-testid="patients-export-excel-button"><Download size={15} /> Export Excel</button>}
        {can("patients:write") && <button className="primary" onClick={() => setShow(true)} data-testid="add-patient-button"><Plus size={18} /> Add patient</button>}
      </PageHeading>
      <div className="toolbar"><div className="search"><Search size={17} /><input data-testid="patient-search-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search name, OPD or phone" /></div><span className="result-count" data-testid="patient-count">{loading ? "Loading…" : `${patients.length} patients`}</span></div>
      <ErrorBox error={error} testid="patients-error" />
      <section className="table-card">
        <div className="table-head patients-grid"><span>Patient</span><span>OPD number</span><span>Contact</span><span>{money ? "Balance" : "Added"}</span><span /></div>
        {patients.length ? patients.map((p) => (
          <button className="table-row patients-grid row-button" key={p.id} onClick={() => navigate(`/patients/${p.id}`)} data-testid={`patient-row-${p.opd}`}>
            <div className="person"><div className="avatar soft">{p.name?.slice(0, 2).toUpperCase()}</div><b>{p.name}</b></div>
            <span className="opd">{p.opd}</span><span>{p.phone || "—"}</span>
            {money ? <span className={p.outstanding > 0 ? "amount due" : p.outstanding < 0 ? "amount credit" : "amount"} data-testid={`patient-balance-${p.opd}`}>{p.outstanding < 0 ? `${inr(-p.outstanding)} advance` : inr(p.outstanding)}</span> : <span>{p.created_at?.slice(0, 10)}</span>}
            <ChevronRight size={16} />
          </button>
        )) : loading ? <div className="empty" data-testid="patients-loading">Loading patients…</div> : <Empty icon={Users} title="No patients yet" text="Add your first patient or approve a voice entry." testid="patients-empty" />}
      </section>
      {show && <PatientForm onClose={() => setShow(false)} onSaved={(p) => { setShow(false); reload(); navigate(`/patients/${p.id}`); }} />}
    </div>
  );
}
